module.exports = function anonymous(it
/**/) {
var out='<div id="scd-overlay" class="scd-hidden" ontouchstart="" tabindex="1"> <h2>'+( it.title )+'</h2> <div class="scd-overlay-container"> <div class="scd-topic scd-zoomed scd-hidden"></div> <ul class="scd-topics"></ul> </div></div>';return out;
}